<template>
  <div>
    <NavBar />
    <AuthBySessionExpired />
    <new-bed @created="getBeds" />
    <view-bed :bed="bed" @updated="getBeds" @close="bed = null" />
    <div class="container">
      <div class="row">
        <div class="col-xl-1 col-lg-2 col-md-2 col-sm-3 col-12 pt-0">
          <v-btn class="btn-return" @click="handleToBack">
            <i class="fas fa-arrow-left mr-2 text-twenty"> </i> Voltar
          </v-btn>
        </div>
        <div class="col-xl-5 col-lg-5 col-md-6 col-sm-9 col-12 pt-0">
          <h1 class="title-pages pt-1 check-text-center">LEITOS</h1>
        </div>
        <div
          class="col-xl-6 col-lg-5 col-md-4 col-sm-12 col-12 pt-0 text-right"
        >
          <v-btn
            v-if="permission('write', 'bed')"
            class="btn-add"
            @click="$bvModal.show('new_bed')"
          >
            <i class="fas fa-plus mr-2 text-twenty"></i> ADICIONAR
          </v-btn>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 pb-0 pt-0">
          <v-text-field
            v-model="search_bedroom"
            prepend-inner-icon="mdi-magnify"
            placeholder="PESQUISAR QUARTO"
            data-type="search_bedroom"
            @keyup="handleFilterBeds"
            outlined
            dense
          />
        </div>
        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 pb-0 pt-0">
          <v-text-field
            v-model="search_number"
            prepend-inner-icon="mdi-magnify"
            placeholder="PESQUISAR Nº"
            data-type="search_number"
            @keyup="handleFilterBeds"
            outlined
            dense
          />
        </div>
        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 pb-0 pt-0">
          <v-text-field
            v-model="search_walk"
            prepend-inner-icon="mdi-magnify"
            placeholder="PESQUISAR ANDAR"
            data-type="search_walk"
            @keyup="handleFilterBeds"
            outlined
            dense
          />
        </div>
        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 pb-0 pt-0">
          <v-text-field
            v-model="search_ward_or_sector"
            prepend-inner-icon="mdi-magnify"
            placeholder="PESQUISAR ALA/SETOR"
            data-type="search_ward_or_sector"
            @keyup="handleFilterBeds"
            outlined
            dense
          />
        </div>
      </div>
      <b-overlay :show="loadingBed" opacity="0.99">
        <div class="v-clean p-5 text-center" v-show="beds.length == 0">
          <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
        </div>
        <v-data-table
          v-show="beds.length > 0"
          v-if="permission('read', 'bed')"
          dense
          :headers="headers"
          :items="beds"
          :footer-props="{
            'items-per-page-options': [50, 75, 100],
            'items-per-page-text': 'Mostrar',
          }"
        >
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn small class="btn-edit m-1" @click="bed = item">
              <i class="fas fa-pencil-alt mr-2 text-twenty" /> EDITAR
            </v-btn>
          </template>
        </v-data-table>
        <ErrorsMessages :errors="errors" />
      </b-overlay>
    </div>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";
import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";
import ErrorsMessages from "../templates/Components/ErrorsMessages";
import routes from "../routes";
import api from "../services/api";
import permission from "../lib/permission";
import { userData } from "../lib/functions";
import NewBed from "../templates/beds/new-bed.vue";
import ViewBed from "../templates/beds/view-bed.vue";

export default {
  name: "Beds",
  components: {
    NavBar,
    AuthBySessionExpired,
    ErrorsMessages,
    NewBed,
    ViewBed,
  },
  data() {
    return {
      permissions: {},
      search_bedroom: "",
      search_number: "",
      search_walk: "",
      search_ward_or_sector: "",
      headers: [
        { text: "Ocupado?", value: "resident_name" },
        { text: "Nº", value: "number" },
        { text: "Andar", value: "walk" },
        { text: "ALA/Setor", value: "ward_or_sector" },
        { text: "QRT", value: "bedroom" },
        { text: "Ações", value: "actions" },
      ],
      rest_home_id: "",
      bed: null,
      beds: [],
      id: "",
      number: "",
      walk: "",
      ward_or_sector: "",
      bedroom: "",
      loadingCreate: false,
      loadingUpdate: false,
      loadingBedUpdate: false,
      loadingBed: true,
      errors: [],
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    permission,
    handleToBack: () => routes.go(-1),

    async handleFilterBeds() {
      try {
        this.loadingBed = true;

        const {
          rest_home_id,
          search_bedroom: bedroom,
          search_number: number,
          search_walk: walk,
          search_ward_or_sector: ward_or_sector,
        } = this;

        let params = {
          rest_home_id,
          bedroom,
          number,
          walk,
          ward_or_sector,
        };

        const response = await api.get("/rest-home/bed/filter", {
          params,
        });

        const { error, errors, beds } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.beds = beds;
        }

        this.loadingBed = false;
      } catch (error) {
        console.log(error);
      }
    },

    retrieve() {
      this.permissions = userData().permissions;
      this.rest_home_id = userData().user.rest_home_id;

      this.getBeds();
    },

    async getBeds(page = 1) {
      try {
        this.loadingBed = true;

        const { rest_home_id } = this;

        let params = {
          rest_home_id,
          page,
        };

        const response = await api.get("/rest-home/bed/paginate", {
          params,
        });

        const { error, errors, beds } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.beds = beds;
        }
        this.loadingBed = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
